import { InvQuantityUnitEnum } from "@brewbase/db/types";
/**
 * The units an inventory quantity (`inv_item.quantity_unit`,
 * `inv_production_component.consumed_quantity_unit`) can be stored in, in
 * picker order.
 */
export const QUANTITY_UNITS = Object.values(InvQuantityUnitEnum);
export function isQuantityUnit(value) {
    return QUANTITY_UNITS.includes(value);
}
const SPELLINGS = {
    mg: InvQuantityUnitEnum.mg,
    g: InvQuantityUnitEnum.g,
    gram: InvQuantityUnitEnum.g,
    grams: InvQuantityUnitEnum.g,
    kg: InvQuantityUnitEnum.kg,
    ml: InvQuantityUnitEnum.mL,
    l: InvQuantityUnitEnum.L,
};
/**
 * Read a free-text unit (a label scan, a legacy value) as a quantity unit:
 * trimmed, case-insensitive, with the spellings the enum migration mapped.
 * Anything else is `null`, so the caller asks the operator rather than guess.
 */
export function parseQuantityUnit(text) {
    if (!text)
        return null;
    return SPELLINGS[text.trim().toLowerCase()] ?? null;
}
//# sourceMappingURL=inventory-quantity-unit.js.map